export default {
  writeOffStatus: process.env.BASE_URL + '/api/v1/exchange/wechatShow',
  writeOff: process.env.BASE_URL + '/api/v1/exchange/wechatComsume'
}